import { render } from "./kanbanBoard.vue?vue&type=template&id=e0b722de"
import script from "./kanbanBoard.vue?vue&type=script&lang=js"
export * from "./kanbanBoard.vue?vue&type=script&lang=js"

import "./kanbanBoard.vue?vue&type=style&index=0&id=e0b722de&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__